/* Liv Wunschkombi – 3D-Konfigurator (MyVesperbox). Benötigt three.js r128 + OrbitControls. */
(function () {
  'use strict';
  const ORDER = ['Blau', 'Türkis', 'Grün', 'Lila', 'Rosa', 'Schwarz'];
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  function b64(s, T) { const bin = atob(s), u = new Uint8Array(bin.length); for (let i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i); return new T(u.buffer); }
  function geo(m) {
    const g = new THREE.BufferGeometry();
    const p = b64(m.p, Int16Array), n = b64(m.n, Int8Array), pos = new Float32Array(p.length), nor = new Float32Array(n.length);
    for (let i = 0; i < p.length; i++) pos[i] = p[i] / 100;
    for (let i = 0; i < n.length; i++) nor[i] = n[i] / 127;
    g.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    g.setAttribute('normal', new THREE.BufferAttribute(nor, 3));
    g.setIndex(new THREE.BufferAttribute(m.i32 ? b64(m.i, Uint32Array) : b64(m.i, Uint16Array), 1));
    return g;
  }
  const seg = (x, a, b) => Math.min(1, Math.max(0, (x - a) / (b - a)));
  const ease = t => t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;

  class LivConfigurator {
    constructor(root) {
      this.root = root;
      this.cfg = JSON.parse(root.querySelector('[data-liv-config]').textContent);
      this.COL = this.cfg.colors;
      const byColor = (a, b) => ORDER.indexOf(a.color) - ORDER.indexOf(b.color);
      this.lids = this.cfg.lids.filter(l => l.available).sort((a, b) => byColor(a, b) || (!!a.decal - !!b.decal) || a.name.localeCompare(b.name, 'de'));
      this.bases = this.cfg.bases.filter(v => v.available).sort(byColor);
      this.inserts = this.cfg.inserts.filter(v => v.available).sort(byColor);
      if (!this.lids.length || !this.bases.length || !this.inserts.length) root.querySelector('[data-liv-soldout]').hidden = false;
      this.st = { lid: 0, base: 0, ins: 0 };
      this.p = 0; this.pTarget = 0; this.view = 'front'; this.need = true; this.tex = {};
      this.goView = () => {}; this.render = () => {};
      this.buildUI();
      this.apply();
      this.initScene();
    }

    buildUI() {
      const r = this.root, strip = r.querySelector('[data-liv-lids]'), filters = r.querySelector('[data-liv-filters]');
      this.firstOf = {};
      this.lids.forEach((L, i) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'liv-lid'; b.dataset.i = i; b.setAttribute('aria-label', L.name);
        if (i > 0 && this.lids[i - 1].color !== L.color) b.classList.add('liv-sep');
        if (this.firstOf[L.color] === undefined) this.firstOf[L.color] = b;
        b.innerHTML = `<img alt="" loading="lazy" width="72" height="62" src="${L.thumb}"><span>${L.motif || 'Uni'}</span><small>${L.low ? 'nur noch ' + L.qty : ''}</small>`;
        b.addEventListener('click', () => { this.st.lid = i; this.apply(); });
        strip.appendChild(b);
      });
      ORDER.filter(c => this.firstOf[c]).forEach(c => {
        const f = document.createElement('button'); f.type = 'button'; f.className = 'liv-fchip'; f.dataset.f = c;
        f.innerHTML = `<i style="background:${this.COL[c] || '#ccc'}"></i>${c}`;
        f.addEventListener('click', () => {
          this.forced = c; clearTimeout(this.ft); this.ft = setTimeout(() => this.forced = null, 900);
          filters.querySelectorAll('.liv-fchip').forEach(x => x.setAttribute('aria-current', x === f));
          strip.scrollTo({ left: this.firstOf[c].offsetLeft - strip.offsetLeft - 2, behavior: reduce() ? 'auto' : 'smooth' });
        });
        filters.appendChild(f);
      });
      strip.addEventListener('scroll', () => this.markFilter(), { passive: true });
      this.strip = strip;
      const dots = (el, list, key) => list.forEach((v, i) => {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'liv-dot'; b.dataset.i = i;
        b.style.background = this.COL[v.color] || '#ccc'; b.setAttribute('aria-label', v.color); b.title = v.color;
        b.addEventListener('click', () => { this.st[key] = i; this.apply(); });
        el.appendChild(b);
      });
      dots(r.querySelector('[data-liv-bases]'), this.bases, 'base');
      dots(r.querySelector('[data-liv-inserts]'), this.inserts, 'ins');
      r.querySelector('[data-liv-toggle]').addEventListener('click', e => {
        this.pTarget = this.pTarget ? 0 : 1;
        e.currentTarget.textContent = this.pTarget ? this.cfg.t.close : this.cfg.t.open;
        this.goView(this.view);
      });
      r.querySelectorAll('[data-liv-view]').forEach(b => b.addEventListener('click', () => { this.view = b.dataset.livView; this.goView(this.view); }));
      r.querySelector('[data-liv-add]').addEventListener('click', () => this.addToCart());
      requestAnimationFrame(() => this.markFilter());
    }
    markFilter() {
      if (this.forced) return;
      const x = this.strip.scrollLeft + this.strip.offsetLeft + 10; let cur = null;
      for (const c of ORDER) if (this.firstOf[c] && this.firstOf[c].offsetLeft <= x) cur = c;
      this.root.querySelectorAll('.liv-fchip').forEach(f => f.setAttribute('aria-current', f.dataset.f === cur));
    }
    sel() { return { lid: this.lids[this.st.lid], base: this.bases[this.st.base], ins: this.inserts[this.st.ins] }; }
    apply() {
      const { lid, base, ins } = this.sel(); if (!lid || !base || !ins) return;
      const r = this.root;
      r.querySelector('[data-liv-lidname]').textContent = lid.name;
      r.querySelector('[data-liv-basename]').textContent = base.color;
      r.querySelector('[data-liv-insname]').textContent = ins.color;
      r.querySelectorAll('[data-liv-lids] .liv-lid').forEach(b => b.setAttribute('aria-pressed', +b.dataset.i === this.st.lid));
      r.querySelectorAll('[data-liv-bases] .liv-dot').forEach(b => b.setAttribute('aria-pressed', +b.dataset.i === this.st.base));
      r.querySelectorAll('[data-liv-inserts] .liv-dot').forEach(b => b.setAttribute('aria-pressed', +b.dataset.i === this.st.ins));
      r.querySelector('[data-liv-msg]').textContent = '';
      if (!this.M) return;
      this.M.lid.color.set(this.COL[lid.color] || '#999').convertSRGBToLinear();
      this.M.base.color.set(this.COL[base.color] || '#999').convertSRGBToLinear();
      this.M.ins.color.set(this.COL[ins.color] || '#999').convertSRGBToLinear();
      if (lid.decal) {
        if (!this.tex[lid.id]) {
          const t = this.loader.load(lid.decal, () => this.render(), undefined, () => { this.decal.visible = false; this.render(); });
          t.encoding = THREE.sRGBEncoding; t.anisotropy = 8; this.tex[lid.id] = t;
        }
        this.decalMat.map = this.tex[lid.id]; this.decalMat.needsUpdate = true; this.decal.visible = true;
      } else this.decal.visible = false;
      this.render();
    }

    async addToCart() {
      const { lid, base, ins } = this.sel(); const btn = this.root.querySelector('[data-liv-add]'), msg = this.root.querySelector('[data-liv-msg]');
      if (!lid || !base || !ins) return;
      btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
      const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: [{ id: this.cfg.parent, quantity: 1, properties: {
        'Deckel': lid.name, 'Unterteil': base.color, 'Einsatz': ins.color,
        '_liv_deckel': String(lid.id), '_liv_unterteil': String(base.id), '_liv_einsatz': String(ins.id) } }] };
      if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(s => s.id); body.sections_url = window.location.pathname; }
      try {
        const res = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || '');
        if (drawer && drawer.renderContents && data.sections) {
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          drawer.renderContents(Object.assign({}, data.items ? data.items[0] : data, { sections: data.sections }));
        } else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      } catch (e) {
        msg.textContent = this.cfg.t.error + (e.message ? ' (' + e.message + ')' : '');
      } finally { btn.removeAttribute('aria-busy'); btn.disabled = false; }
    }

    async initScene() {
      const stage = this.root.querySelector('[data-liv-stage]');
      try { const mesh = await fetch(this.cfg.model).then(r => r.json()); this.setup(stage, mesh); }
      catch (e) { stage.classList.add('liv-nogl'); console.warn('Liv 3D:', e); }
      this.apply();
    }
    setup(stage, MESH) {
      const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      renderer.setPixelRatio(Math.min(devicePixelRatio, 2)); renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.shadowMap.enabled = true; renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      stage.appendChild(renderer.domElement); stage.classList.add('liv-ready');
      const scene = new THREE.Scene(), cam = new THREE.PerspectiveCamera(30, 1, 10, 6000);
      const ctl = new THREE.OrbitControls(cam, renderer.domElement);
      Object.assign(ctl, { enableDamping: true, minDistance: 250, maxDistance: 1100, maxPolarAngle: Math.PI * 0.49, enablePan: false });
      scene.add(new THREE.HemisphereLight(0xffffff, 0x9fb1b8, 0.5));
      const key = new THREE.DirectionalLight(0xffffff, 0.62); key.position.set(-250, 420, 300); key.castShadow = true; key.shadow.mapSize.set(2048, 2048);
      Object.assign(key.shadow.camera, { left: -350, right: 350, top: 350, bottom: -350, near: 50, far: 1600 }); key.shadow.bias = -0.0005; scene.add(key);
      const rim = new THREE.DirectionalLight(0xffffff, 0.25); rim.position.set(300, 200, -300); scene.add(rim);
      const ground = new THREE.Mesh(new THREE.PlaneGeometry(3000, 3000), new THREE.ShadowMaterial({ opacity: 0.16 }));
      ground.rotation.x = -Math.PI / 2; ground.position.y = -38.6; ground.receiveShadow = true; scene.add(ground);
      const mat = () => new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.5, metalness: 0 });
      const M = this.M = { lid: mat(), base: mat(), ins: mat() };
      const add = (k, m, parent) => { const me = new THREE.Mesh(geo(MESH[k]), m); me.castShadow = true; me.receiveShadow = true; parent.add(me); return me; };
      // CAD-Koordinaten: z oben, vorne = -y. Scharnierachse (aus STEP offen/geschlossen): x-Achse durch y=80.5, z=1
      const root = new THREE.Group(); root.rotation.x = -Math.PI / 2; scene.add(root);
      add('base', M.base, root); add('baseMark', M.base, root);
      const lidPivot = new THREE.Group(); lidPivot.position.set(0, 80.5, 1); root.add(lidPivot);
      const lidG = new THREE.Group(); lidG.position.set(0, -80.5, -1); lidPivot.add(lidG);
      add('lid', M.lid, lidG); add('logoFill', M.lid, lidG);
      const claspPivot = new THREE.Group(); claspPivot.position.set(0, -80, 4); lidG.add(claspPivot);
      const claspG = new THREE.Group(); claspG.position.set(0, 80, -4); claspPivot.add(claspG); add('clasp', M.lid, claspG);
      const insG = new THREE.Group(); root.add(insG); add('insert', M.ins, insG);
      this.loader = new THREE.TextureLoader(); this.loader.setCrossOrigin('anonymous');
      this.decalMat = new THREE.MeshStandardMaterial({ transparent: true, roughness: 0.45, polygonOffset: true, polygonOffsetFactor: -2 });
      this.decal = new THREE.Mesh(new THREE.PlaneGeometry(184, 184 / 1.31), this.decalMat); this.decal.position.set(0, 0, 10.05); lidG.add(this.decal);
      const logoTex = this.loader.load(this.cfg.logo, () => this.render()); logoTex.encoding = THREE.sRGBEncoding; logoTex.anisotropy = 8;
      const logo = new THREE.Mesh(new THREE.PlaneGeometry(82, 82 * 0.1826), new THREE.MeshStandardMaterial({ map: logoTex, transparent: true, roughness: 0.45, polygonOffset: true, polygonOffsetFactor: -4 }));
      logo.position.set(1.8, -49.5, 10.1); lidG.add(logo);
      const pose = () => {
        const a = ease(seg(this.p, 0, 0.28)), b = ease(seg(this.p, 0.2, 0.72)), u = ease(seg(this.p, 0.62, 1));
        claspPivot.rotation.x = -Math.PI * a; lidPivot.rotation.x = -Math.PI * b;
        insG.position.set(85 * (1 - u), -10 * (1 - u), -2.4 * (1 - u) + 60 * Math.sin(Math.PI * u));
        root.position.x = -40 * (1 - u);
      };
      const VIEWS = { closed: { front: [[-160, 265, 430], [12, -8, 0]], top: [[12, 560, 40], [12, -8, 0]] }, open: { front: [[-230, 360, 470], [0, -10, -70]], top: [[0, 760, -60], [0, -10, -70]] } };
      let tween = null;
      this.goView = (v, animate = true) => {
        const set = VIEWS[this.pTarget ? 'open' : 'closed'][v]; const pos = new THREE.Vector3(...set[0]), tgt = new THREE.Vector3(...set[1]);
        if (!animate || reduce()) { cam.position.copy(pos); ctl.target.copy(tgt); ctl.update(); this.render(); return; }
        tween = { t: 0, fp: cam.position.clone(), ft: ctl.target.clone(), pos, tgt };
      };
      this.render = () => { this.need = true; };
      const resize = () => { const w = stage.clientWidth, h = stage.clientHeight; if (!w || !h) return; renderer.setSize(w, h, false); cam.aspect = w / h; cam.updateProjectionMatrix(); this.render(); };
      ctl.addEventListener('change', this.render);
      new ResizeObserver(resize).observe(stage);
      let visible = true;
      new IntersectionObserver(es => { visible = es[0].isIntersecting; }).observe(stage);
      let last = performance.now();
      const loop = now => {
        requestAnimationFrame(loop); const dt = Math.min(.05, (now - last) / 1000); last = now;
        if (!visible) return;
        if (this.p !== this.pTarget) { this.p += Math.sign(this.pTarget - this.p) * dt * (reduce() ? 100 : 0.55); if ((this.pTarget - this.p) * (this.pTarget ? 1 : -1) < 0 || Math.abs(this.pTarget - this.p) < 1e-3) this.p = this.pTarget; pose(); this.need = true; }
        if (tween) { tween.t = Math.min(1, tween.t + dt * 1.4); const k = ease(tween.t); cam.position.lerpVectors(tween.fp, tween.pos, k); ctl.target.lerpVectors(tween.ft, tween.tgt, k); if (tween.t >= 1) tween = null; this.need = true; }
        if (ctl.update() || this.need) { renderer.render(scene, cam); this.need = false; }
      };
      pose(); resize(); this.goView('front', false); requestAnimationFrame(loop);
    }
  }

  function boot() {
    document.querySelectorAll('[data-liv-configurator]:not([data-liv-init])').forEach(el => {
      el.setAttribute('data-liv-init', '');
      const start = () => new LivConfigurator(el);
      if (window.THREE && THREE.OrbitControls) start(); else window.addEventListener('liv:three-ready', start, { once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
